<template>
  <!--转盘抽奖记录页面-->
  <tk-container
    disable-scroll
  >
    <!--列表头部-->
    <grey-header slot="header" :title="'我的奖品'" :icon="'return'"></grey-header>
    <!--记录列表-->
    <tk-container
      infiniteScroll
      ref="resetDrawRecords"
      class="b-g-f"
      @loadingMore="getDrawRecords"
    >
      <div
        v-for="(s, index) in drawRecords"
        :key="index"
      >
        <tk-flex
          middle
          between
          class="p-12"
        >
          <div>
            <div class="font-14">{{'奖品：' + s.prize}}</div>
            <div class="caption m-t-10">{{s.createdAt | datetime}}</div>
          </div>
          <tk-flex column style="width: 160px;">
            <tk-flex middle class="font-14 full-width">
              <div style="flex-shrink: 0;">状态：</div>
              <div class="font-14">{{s.isIssue ? '已发放' : '未发放'}}</div>
            </tk-flex>
            <tk-flex middle class="caption m-t-10 full-width">
              <div style="flex-shrink: 0;">物流单号：</div>
              <div style="flex-shrink: 1;word-break:break-all">{{ s.logisticsNumber ? s.logisticsNumber : '请耐心等待' }}</div>
            </tk-flex>
          </tk-flex>
        </tk-flex>
      </div>
    </tk-container>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: false, // 页面状态
      drawRecords: [] // 幸运星记录数据
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
     * 获取奖品记录数据
     * @date: 2020/4/16
     */
    async getDrawRecords (page, next) {
      let drawRecords = await this.$tkParse.getList(`/classes/drawRecords`, {
        params: {
          limit: 10,
          skip: page * 10,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      this.drawRecords = [...this.drawRecords, ...drawRecords]
      if (drawRecords.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
